// auth
export const CLEAR_SESSION = 'CLEAR_SESSION';
export const SET_SESSION_STARTED = 'SET_SESSION_STARTED';
export const SET_SESSION_SUCCESS = 'SET_SESSION_SUCCESS';
export const SET_SESSION_FAILED = 'SET_SESSION_FAILED';
export const CHECK_AUTH_TOKEN = 'CHECK_AUTH_TOKEN';
export const REFRESH_AUTH_TOKEN_STARTED = 'REFRESH_AUTH_TOKEN_STARTED';
export const REFRESH_AUTH_TOKEN_SUCCESS = 'REFRESH_AUTH_TOKEN_SUCCESS';
export const REFRESH_AUTH_TOKEN_FAILED = 'REFRESH_AUTH_TOKEN_FAILED';
export const USER_CREATE_SUCCESS = 'USER_CREATE_SUCCESS';
export const USER_CREATE_STARTED = 'USER_CREATE_STARTED';
export const USER_CREATE_FAILED = 'USER_CREATE_FAILED';

// register
export const REGISTER_FAILED = 'REGISTER_FAILED';
export const REGISTER_STARTED = 'REGISTER_STARTED';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const CONFIRMATION_FAILED = 'CONFIRMATION_FAILED';
export const CONFIRMATION_STARTED = 'CONFIRMATION_STARTED';
export const CONFIRMATION_SUCCESS = 'CONFIRMATION_SUCCESS';
export const RESEND_CODE_FAILED = 'RESEND_CODE_FAILED';
export const RESEND_CODE_STARTED = 'RESEND_CODE_STARTED';
export const RESEND_CODE_SUCCESS = 'RESEND_CODE_SUCCESS';
// search
export const SEARCH_START = 'SEARCH_START';
export const SEARCH_END = 'SEARCH_END';
export const SEARCH_NO_REFRESH = 'SEARCH_NO_REFRESH';
export const SEARCH_REFRESH = 'SEARCH_REFRESH';
// reset
export const FORGOT_PASSWORD_FAILED = 'FORGOT_PASSWORD_FAILED';
export const FORGOT_PASSWORD_STARTED = 'FORGOT_PASSWORD_STARTED';
export const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
export const RESET_PASSWORD_STARTED = 'RESET_PASSWORD_STARTED';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED';
// fetch
export const FETCH_DISCOGS_STARTED = 'FETCH_DISCOGS_STARTED';
export const FETCH_DISCOGS_SUCCESS = 'FETCH_DISCOGS_SUCCESS';
export const FETCH_DISCOGS_FAILED = 'FETCH_DISCOGS_FAILED';
